import React, { FC } from 'react';
import { Box, Container, makeStyles, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

interface ProjectsTextSectionProps {
  text: string;
}
interface ProjectsTextArrayProps {
  textList: Array<ProjectsTextSectionProps>;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      margin: theme.spacing(7, 0, 0),
    },
    divider: {
      width: 100,
      height: 1,
      backgroundColor: theme.palette.primary.main,
      marginBottom: theme.spacing(6),
    },
    text: {
      marginTop: theme.spacing(3),
    },
  });
});

const ProjectsTextSection: FC<ProjectsTextArrayProps> = ({ textList }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Container fixed>
        <Box className={classes.divider} />
        {textList.map((item, index) => (
          <Typography className={classes.text} key={index} data-aos="fade-up" data-aos-duration="1500">
            {item.text}
          </Typography>
        ))}
      </Container>
    </Box>
  );
};

export default ProjectsTextSection;
